import React from 'react';
import { Box, Typography } from '@mui/material';
import { getRag, RAG_COLORS, formatPeriod } from '../../utils/ragUtils';

const ICON = { green: '●', amber: '▲', red: '✕' };

function SingleBadge({ value, year, month, label, ragGreen, ragRed, direction, decimals }) {
  const rag    = getRag(value, ragGreen, ragRed, direction);
  const colors = RAG_COLORS[rag];

  return (
    <Box>
      <Typography sx={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: 0.5, display: 'block', mb: 0.4 }}>
        {label} · {formatPeriod(year, month)}
      </Typography>
      <Box sx={{
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'space-between',
        px:             1,
        py:             0.6,
        borderRadius:   1,
        bgcolor:        colors.bg,
        border:         `0.5px solid ${colors.border}`,
        minWidth:       100,
      }}>
        <Typography sx={{ fontSize: 11, fontWeight: 500, color: colors.text }}>
          {ICON[rag]}
        </Typography>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: colors.text, fontVariantNumeric: 'tabular-nums' }}>
          {value.toFixed(decimals)}
        </Typography>
      </Box>
    </Box>
  );
}

export default function Beacon4BlendedRagBadge({ series, config }) {
  if (!series || !config) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 1, minWidth: 115 }}>
      <SingleBadge
        value={series.lastRealValue}
        year={series.lastRealYear}
        month={series.lastRealMonth}
        label="Real"
        ragGreen={series.lastRagGreen}
        ragRed={series.lastRagRed}
        direction={config.direction}
        decimals={config.decimals}
      />
      <Box sx={{ height: '0.5px', bgcolor: '#e0e0e0' }} />
      <SingleBadge
        value={series.nextProjValue}
        year={series.nextProjYear}
        month={series.nextProjMonth}
        label="Proj."
        ragGreen={series.lastRagGreen}
        ragRed={series.lastRagRed}
        direction={config.direction}
        decimals={config.decimals}
      />
    </Box>
  );
}